import scheduleWeekdays from "./scheduleWeekdays.component";

const scheduleWeekdaysModule = angular
  .module("app.components.scheduleWeekdays", [])
  .component("scheduleWeekdays", scheduleWeekdays);

export default scheduleWeekdaysModule;



// WEBPACK FOOTER //
// ./src/components/scheduleWeekdays/scheduleWeekdays.module.js